import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';

function CurrencyCodesPage() {

    return <Page header="Currency codes">
        <Table
            headers={['Currency', 'ISO 4217 code']}
            body={[
                ['Afghan Afghani', <code>AFN</code>],
                ['Albanian Lek', <code>ALL</code>],
                ['Algerian Dinar', <code>DZD</code>],
                ['Angolan Kwanza', <code>AOA</code>],
                ['Arab Emirates Dirham', <code>AED</code>],
                ['Argentine Peso', <code>ARS</code>],
                ['Armenian Dram', <code>AMD</code>],
                ['Aruban Guilder', <code>AWG</code>],
                ['Australian Dollar', <code>AUD</code>],
                ['Azerbaijani manat', <code>AZN</code>],
                ['Bahamian Dollar', <code>BSD</code>],
                ['Bahraini Dinar', <code>BHD</code>],
                ['Bangladeshi Taka', <code>BDT</code>],                
                ['Barbados Dollar', <code>BBD</code>],
                ['Belarusian Ruble', <code>BYR</code>],
                ['Belize Dollar', <code>BZD</code>],
                ['Bermudian Dollar', <code>BMD</code>],
                ['Bhutanese Ngultrum', <code>BTN</code>],
                ['Boliviano', <code>BOB</code>],                
                ['Bosnia and Herzegovina Convertible Marka', <code>BAM</code>],
                ['Botswana Pula', <code>BWP</code>],
                ['Brazil Real', <code>BRL</code>],
                ['Brunei Dollar', <code>BND</code>],
                ['Bulgarian lev', <code>BGN</code>],
                ['Burundi Franc', <code>BIF</code>],
                ['Cambodian Riel', <code>KHR</code>],
                ['Canadian Dollar', <code>CAD</code>],
                ['Cape Verde Escudo', <code>CVE</code>],
                ['Cayman Islands Dollar', <code>KYD</code>],
                ['CFA franc BEAC', <code>XAF</code>],
                ['Chilean Peso', <code>CLP</code>],                
                ['Communauté Financière Africaine (BCEAO) Franc', <code>XOF</code>],
                ['Comoros Franc', <code>KMF</code>],
                ['Comptoirs Franç ais du Pacifique (CFP) Franc', <code>XPF</code>],
                ['Congolese Franc', <code>CDF</code>],
                ['Costa Rican Colon', <code>CRC</code>],
                ['Croatian Kuna', <code>HRK</code>],
                ['Cuban convertible peso', <code>CUC</code>],
                ['Cuban Peso', <code>CUP</code>],                
                ['Czech Koruna', <code>CZK</code>],
                ['Danish Krone', <code>DKK</code>],
                ['Denar', <code>MKD</code>],
                ['Djibouti Franc', <code>DJF</code>],
                ['Dobra', <code>STD</code>],
                ['Dominican Peso', <code>DOP</code>],
                ['East Caribbean dollar', <code>XCD</code>],
                ['Egyptian Pound', <code>EGP</code>],
                ['Ethiopian Birr', <code>ETB</code>],
                ['Eritrean Nakfa', <code>ERN</code>],
                ['Euro', <code>EUR</code>],
                ['Falkland Islands Pound', <code>FKP</code>],
                ['Fiji Dollar', <code>FJD</code>],
                ['Gambian Dalasi', <code>GMD</code>],
                ['Georgian Lari', <code>GEL</code>],
                ['Ghanaian cedi', <code>GHS</code>],
                ['Gibraltar Pound', <code>GIP</code>],
                ['Guatemalan Quetzal', <code>GTQ</code>],
                ['Guinea Franc', <code>GNF</code>],
                ['Guyana Dollar', <code>GYD</code>],                
                ['Haitian Gourde', <code>HTG</code>],
                ['Honduran Lempira', <code>HNL</code>],
                ['Hong Kong Dollar', <code>HKD</code>],
                ['Hungarian Forint', <code>HUF</code>],
                ['Iceland Krona', <code>ISK</code>],
                ['Indian Rupee', <code>INR</code>],
                ['Indonesian Rupiah', <code>IDR</code>],
                ['International Monetary Fund (IMF) Special Drawing Rights', <code>XDR</code>],
                ['Iranian Rial', <code>IRR</code>],
                ['Iraqi Dinar', <code>IQD</code>],
                ['Israeli New Shekel', <code>ILS</code>],
                ['Jamaican Dollar', <code>JMD</code>],
                ['Japanese Yen', <code>JPY</code>],
                ['Jordanian Dinar', <code>JOD</code>],
                ['Kazakhstan Tenge', <code>KZT</code>],
                ['Kenyan Shilling', <code>KES</code>],
                ['Korean Won', <code>KRW</code>],
                ['Kuwaiti Dinar', <code>KWD</code>],
                ['Kyrgyzstani Som', <code>KGS</code>],
                ['Lao Kip', <code>LAK</code>],
                ['Lebanese Pound', <code>LBP</code>],
                ['Lesotho Loti', <code>LSL</code>],
                ['Liberian Dollar', <code>LRD</code>],
                ['Libyan Dinar', <code>LYD</code>],
                ['Macau Pataca', <code>MOP</code>],
                ['Malagasy Ariary', <code>MGA</code>],
                ['Malawi Kwacha', <code>MWK</code>],                
                ['Malaysian Ringgit', <code>MYR</code>],
                ['Maldive Rufiyaa', <code>MVR</code>],
                ['Mauritanian Ouguiya', <code>MRO</code>],
                ['Mauritius Rupee', <code>MUR</code>],
                ['Mexican Nuevo Peso', <code>MXN</code>],
                ['Mongolian Tugrik', <code>MNT</code>],
                ['Moldovan Leu', <code>MDL</code>],
                ['Moroccan Dirham', <code>MAD</code>],
                ['Mozambican metical', <code>MZN</code>],
                ['Myanmar Kyat', <code>MMK</code>],
                ['Namibian Dollar', <code>NAD</code>],
                ['Nepalese Rupee', <code>NPR</code>],
                ['Netherlands Antillean guilder', <code>ANG</code>],
                ['New Zealand Dollar', <code>NZD</code>],
                ['New Taiwan dollar', <code>TWD</code>],
                ['Nicaraguan Cordoba Oro', <code>NIO</code>],
                ['Nigerian Naira', <code>NGN</code>],
                ['North Korean Won', <code>KPW</code>],
                ['Norwegian Krone', <code>NOK</code>],
                ['Omani Rial', <code>OMR</code>],
                ['Pakistan Rupee', <code>PKR</code>],
                ['Panamanian Balboa', <code>PAB</code>],
                ['Papua New Guinea Kina', <code>PGK</code>],
                ['Paraguay Guarani', <code>PYG</code>],
                ['Peruvian Nuevo Sol', <code>PEN</code>],
                ['Philippine Peso', <code>PHP</code>],
                ['Poland Zloty', <code>PLN</code>],
                ['Pound sterling', <code>GBP</code>],
                ['Qatari Rial', <code>QAR</code>],
                ['Romanian new leu', <code>RON</code>],
                ['Russian Ruble', <code>RUB</code>],
                ['Rwanda Franc', <code>RWF</code>],
                ['Samoan Tala', <code>WST</code>],
                ['Saudi Riyal', <code>SAR</code>],
                ['Serbian dinar', <code>RSD</code>],
                ['Seychelles Rupee', <code>SCR</code>],
                ['Sierra Leone Leone', <code>SLL</code>],
                ['Singapore Dollar', <code>SGD</code>],
                ['Solomon Islands Dollar', <code>SBD</code>],
                ['Somali Shilling', <code>SOS</code>],
                ['South African Rand', <code>ZAR</code>],
                ['South Sudan Pound', <code>SSP</code>],
                ['Sri Lanka Rupee', <code>LKR</code>],
                ['St. Helena Pound', <code>SHP</code>],
                ['Sudanese pound', <code>SDG</code>],
                ['Suriname Dollar', <code>SRD</code>],
                ['Swaziland Lilangeni', <code>SZL</code>],
                ['Swedish Krona', <code>SEK</code>],
                ['Swiss Franc', <code>CHF</code>],
                ['Syrian Pound', <code>SYP</code>],
                ['Tajikistani Somoni', <code>TJS</code>],
                ['Tanzanian Shilling', <code>TZS</code>],
                ['Thai Baht', <code>THB</code>],
                ['Tongan Paanga', <code>TOP</code>],
                ['Trinidad and Tobago Dollar', <code>TTD</code>],
                ['Tunisian Dollar', <code>TND</code>],
                ['Turkish lira', <code>TRY</code>],
                ['Turkmenistani manat', <code>TMT</code>],                
                ['Uganda Shilling', <code>UGX</code>],
                ['Ukrainian Hryvnia', <code>UAH</code>],
                ['Uruguayan Peso', <code>UYU</code>],
                ['US Dollar', <code>USD</code>],               
                ['Uzbekistan Sum', <code>UZS</code>],
                ['Vanuatu Vatu', <code>VUV</code>],
                ['Venezuelan bolívar', <code>VEF</code>],
                ['Vietnamese Dong', <code>VND</code>],
                ['Yemeni Rial', <code>YER</code>],
                ['Yuan Renminbi', <code>CNY</code>],
                ['Zambia Kwacha', <code>ZMW</code>],                
                ['Zimbabwean Dollar', <code>ZWL</code>],
            ]}
        />
    </Page>
}

export default CurrencyCodesPage;